import React from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import buildingImage from '../../assets/images/buildings.jpg';
import '../../Share/Style.css';
import Footer from '../../Share/Footer';
import UseData from '../../Hooks/UseData';
import SliderCommon from '../../Share/SliderCommon';
import PageTitle from '../../Share/PageTitle';

const Evaluation = () => {
  const { local, experienceArray } = UseData();
  return (
    <>
      <PageTitle title='Valutazioni immobiliari'></PageTitle>
      {/* End pagetitle */}

      <section>
        <div className='container lg:rounded-2xl bg-white dark:bg-[#111111]  px-4 sm:px-5 md:px-10 lg:px-20'>
          <div data-aos='fade'>
            <div className='py-12'>
              {/* Page Title */}
              <h2 className='after-effect after:left-26 mt-12 lg:mt-0 additional-margin'>
                Valutazioni immobiliari
              </h2>
              <div className='grid grid-cols-12 md:gap-10 pt-4 md:pt-[40px] items-center'>
                <div className='col-span-12 md:col-span-4'>
                  {/* personal images for about page  */}
                  <img
                    className='w-full md:w-[330px] md:h-[400px] object-cover overflow-hidden rounded-[35px] mb-3 md:mb-0'
                    src={buildingImage}
                    alt=''
                  />
                </div>
                <div className='col-span-12 md:col-span-8 space-y-2.5'>
                  {/* About me information */}
                  <div className=' md:mr-12 xl:mr-16'>
                    <h3 className='text-4xl font-medium dark:text-white mb-2.5 '>
                      Basi di valore
                    </h3>
                    <p className='text-gray-lite  dark:text-color-910 leading-7'>
                      <ul>
                        <li>Metodo comparativo del mercato (MCA)</li>
                        <li>Metodo reddituale/capitalizzazione diretta</li>
                        <li>Valore di investimento</li>
                        <li>Analisi dei ﬂussi di cassa attualizzati (DCFA)</li>
                        <li>Metodo del costo</li>
                      </ul>
                    </p>
                    <h3 className='text-4xl font-medium dark:text-white mb-2.5 '>
                      Approccio valutativo
                    </h3>
                    <p className='text-gray-lite  dark:text-color-910 leading-7'>
                      <ul>
                        <li>Valore di mercato</li>
                        <li>Canone di mercato</li>
                        <li>Valore di investimento</li>
                        <li>Fair value</li>
                        <li>Valutazione ai fini bilancistici (IAS/IFRS)</li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='pb-12'>
              <h3 className='text-4xl font-medium dark:text-white mb-2.5 '>
                Standard e Metodologie
              </h3>
              <p className='text-gray-lite dark:text-color-910 leading-7 mb-10'>
                Valutazioni immobiliari redatte secondo gli Standard Europei di
                Valutazione EVS (European Valuation Standards), mediante
                applicazione delle principali metodologie estimative (Market
                Comparison Approach, Income Approach e Cost Approach)
                selezionate in funzione della tipologia immobiliare e della
                finalità della stima, con esplicitazione di: scopo e base del
                valore, perimetro e limiti dell’incarico, presupposti e
                condizioni, analisi del mercato di riferimento, criteri di
                comparabilità, verifiche di coerenza e sintesi conclusiva.
              </p>
              {/* Slick Slider call here  */}
              <SliderCommon />
            </div>

            {/* Common Footer call here */}
            <Footer condition={false} bg={'#FFFF'} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Evaluation;
